/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdviserSummaryDto } from './AdviserSummaryDto';
import type { ClientBasicInfoDto } from './ClientBasicInfoDto';
export type QuoteResponsePublicDto = {
    /**
     * Quote UUID
     */
    id: string;
    /**
     * Client UUID
     */
    clientId: string;
    /**
     * Basic client information
     */
    client: ClientBasicInfoDto;
    /**
     * Local quote status
     */
    status: QuoteResponsePublicDto.status;
    /**
     * Whether this quote is a standard new-business quote or a renewal modification quote
     */
    quoteClassification: QuoteResponsePublicDto.quoteClassification;
    /**
     * When quoteClassification is RENEWAL, the renewal record this quote was created from
     */
    renewalId?: string;
    /**
     * Assigned adviser UUID
     */
    assignedAdviserId?: string;
    /**
     * Servicing adviser UUID
     */
    servicingAdviserId?: string;
    /**
     * Assigned adviser summary (UUID + name)
     */
    assignedAdviser?: AdviserSummaryDto | null;
    /**
     * Servicing adviser summary (UUID + name)
     */
    servicingAdviser?: AdviserSummaryDto | null;
    /**
     * Ando quote reference (header.quote_id)
     */
    andoQuoteId?: string;
    /**
     * Policy cover start date (header.cover_start_date)
     */
    coverStartDate?: string;
    /**
     * Total premium
     */
    totalPremium?: number;
    /**
     * Total tax
     */
    totalTax?: number;
    /**
     * Policy total tax (15% of net premium + fees)
     */
    policyTotalTax?: number;
    /**
     * Total net premium
     */
    totalNetPremium?: number;
    /**
     * Policy net total (ando net premium + admin fee + broker fee, ex GST)
     */
    policyNetTotal?: number;
    /**
     * Admin fee
     */
    adminFee?: number;
    /**
     * Broker fee
     */
    brokerFee?: number;
    /**
     * Total (totalPremium + adminFee + brokerFee)
     */
    total?: number;
    /**
     * Per-risk premium details from Ando response (JSON array)
     */
    riskPremiums?: Record<string, any>;
    /**
     * Quote risks
     */
    risks: Array<string>;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
};
export namespace QuoteResponsePublicDto {
    /**
     * Local quote status
     */
    export enum status {
        DRAFT = 'DRAFT',
        QUOTED = 'QUOTED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        CANCELLED = 'CANCELLED',
        BOUND = 'BOUND',
        DECLINED = 'DECLINED',
    }
    /**
     * Whether this quote is a standard new-business quote or a renewal modification quote
     */
    export enum quoteClassification {
        STANDARD = 'STANDARD',
        RENEWAL = 'RENEWAL',
        MTA = 'MTA',
    }
}

